import { Component } from '@angular/core';

@Component({
  selector: 'avenir-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear(); // Get the current year

}
